import { Link } from 'react-router-dom';
import './Button.css';

/**
 * Единая кнопка. Рендерится как ссылка, если передан `to` (внутренний маршрут)
 * или `href` (внешний адрес), иначе — как <button>.
 *
 * @param {object} props
 * @param {'primary'|'ghost'} [props.variant]
 * @param {'sm'|'md'|'lg'} [props.size]
 */
function Button({
  children,
  to,
  href,
  variant = 'primary',
  size = 'md',
  type = 'button',
  className = '',
  ...rest
}) {
  const classes = ['btn', `btn--${variant}`, size !== 'md' ? `btn--${size}` : '', className]
    .filter(Boolean)
    .join(' ');

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        <span className="btn__label">{children}</span>
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} {...rest}>
        <span className="btn__label">{children}</span>
      </a>
    );
  }

  return (
    <button type={type} className={classes} {...rest}>
      <span className="btn__label">{children}</span>
    </button>
  );
}

export default Button;
